import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useStyles } from './styles/CustomDatePicker.styles';
import { TextField, useMediaQuery } from '@mui/material';
import { LocalizationProvider, DesktopDateRangePicker, MobileDateRangePicker } from '@mui/x-date-pickers-pro';
import React from 'react';
import { dateFormat } from '@utils/dates';
import { CalendarIcon } from '../assets';
import { useTheme } from '@mui/material/styles';

interface CustomDatePickerProps {
    dateRange: { startDate: string; endDate: string };
    setDateRange: (range: { startDate: string; endDate: string }) => void;
    buttonSize?: { width: number; height: number };
    showSpan?: boolean;
    dateRangeError?: string;
    disabled?: boolean;
    greyed?: boolean;
}

export const CustomDatePicker = ({
    dateRangeError,
    dateRange,
    showSpan,
    buttonSize,
    setDateRange,
    disabled = false,
    greyed = false,
}: CustomDatePickerProps) => {
    const classes = useStyles();

    const updateDate = (dates: string[]) => {
        const [startDate, endDate] = dates.map((date) => dateFormat(date));
        setDateRange({ startDate, endDate });
    };

    const theme = useTheme();
    const desktop = useMediaQuery(theme.breakpoints.up('lg'));

    const renderInput = (startProps: any, endProps: any) => (
        <React.Fragment>
            <TextField
                disabled={disabled}
                size={'small'}
                {...startProps}
                label={''}
                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, maxWidth: '150px' }}
                InputProps={{
                    style: { backgroundColor: greyed ? '#EBEBEB' : 'white', ...buttonSize },
                    readOnly: true,
                    endAdornment: <CalendarIcon />,
                }}
                InputLabelProps={{ shrink: true }}
                helperText={dateRangeError ?? ''}
                error={Boolean(dateRangeError)}
            />

            <span style={{ color: 'white' }}> - </span>

            <TextField
                disabled={disabled}
                size={'small'}
                {...endProps}
                label={''}
                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, maxWidth: '150px', ...buttonSize }}
                InputProps={{
                    style: { backgroundColor: greyed ? '#EBEBEB' : 'white', ...buttonSize },
                    readOnly: true,
                    endAdornment: <CalendarIcon />,
                }}
                InputLabelProps={{ shrink: true }}
                helperText={dateRangeError ? 'Date Out of Range' : ''}
                error={dateRangeError}
            />
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {showSpan && (
                <span style={{ color: 'white' }} className={classes.filterByDateText}>
                    Filter by Date
                </span>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                {desktop ? (
                    <DesktopDateRangePicker
                        disabled={disabled}
                        disableAutoMonthSwitching
                        value={[dateRange.startDate, dateRange.endDate]}
                        onChange={(dates) => updateDate(dates as string[])}
                        renderInput={renderInput}
                    />
                ) : (
                    <MobileDateRangePicker
                        disabled={disabled}
                        disableAutoMonthSwitching
                        value={[dateRange.startDate, dateRange.endDate]}
                        onChange={(dates) => updateDate(dates as string[])}
                        renderInput={renderInput}
                    />
                )}
            </LocalizationProvider>
        </React.Fragment>
    );
};
